import { Configuration, LogLevel } from '@azure/msal-browser'
import { env } from './env'

const getClientId = (): string => {
  const clientId = env.AZURE_CLIENT_ID
  if (!clientId) {
    throw new Error("Missing environment variable: REACT_APP_AZURE_CLIENT_ID")
  }
  return clientId
}

const getRedirectUri = (): string => {
  return env.REDIRECT_URI || 'http://localhost:3000/'
}

const getAuthority = (): string => {
  const tenantId = env.AZURE_TENANT_ID
  if (!tenantId) {
    throw new Error("Missing environment variable: REACT_APP_AZURE_TENANT_ID")
  }
  return `https://login.microsoftonline.com/${tenantId}`
}

export const msalConfig: Configuration = {
  auth: {
    clientId: getClientId(),
    redirectUri: getRedirectUri(),
    authority: getAuthority(),
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    tokenRenewalOffsetSeconds: 300,
    allowRedirectInIframe: false,
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        switch (logLevel) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
          default:
            return
        }
      },
    },
  },
}
